import React from 'react';
import { useTranslation } from 'react-i18next';

import { styled, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useValidateUserSupportRole } from '../../hooks/useValidateUserForm';
import { useUserCreationFormContext } from '../../CreateUserContext/CreateUserFormContext';

const StyTopBarContainer = styled('div')(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1.25),
}));

type Props = {
    handleCloseModal: () => void;
    onSaveClick: () => void;
};

const EditUserModalTopBar = ({
    handleCloseModal,
    onSaveClick,
}: Props): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();
    const userCreationForm = useUserCreationFormContext();
    const notAllowedSupportRoleMessage =
        useValidateUserSupportRole(userCreationForm);

    return (
        <StyTopBarContainer>
            <Typography
                sx={{ padding: `0 ${theme.spacing(2.5)}` }}
                variant="h4"
            >
                {t('adminSpace.editUser.buttonLabel')}
            </Typography>
            <div style={{ alignItems: 'center', display: 'flex' }}>
                <Tooltip title={notAllowedSupportRoleMessage}>
                    <span>
                        <Button
                            className="pendo-update-user-confirm"
                            disabled={!!notAllowedSupportRoleMessage}
                            onClick={onSaveClick}
                            variant="contained"
                        >
                            {t('adminSpace.editUser.modal.saveButton')}
                        </Button>
                    </span>
                </Tooltip>
                <IconButton
                    onClick={handleCloseModal}
                    sx={{ marginLeft: theme.spacing(1.25) }}
                >
                    <CloseIcon fontSize="medium" />
                </IconButton>
            </div>
        </StyTopBarContainer>
    );
};

export default EditUserModalTopBar;
